import React, { useEffect, useState } from "react";
import { X, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { getCurrentOffer } from "@/lib/offers";
import { logAttribution } from "@/lib/tracking";

const HIDE_KEY = "ehc_announce_hidden";
const HIDE_DAYS = 7;
const AB_HEIGHT = "44px";

export default function AnnouncementBar() {
  const [visible, setVisible] = useState(false);
  const offer = getCurrentOffer();

  useEffect(() => {
    try {
      const raw = localStorage.getItem(HIDE_KEY);
      if (raw) {
        const until = parseInt(raw, 10);
        if (!Number.isNaN(until) && Date.now() < until) return;
      }
      setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  // Expose AB height to the rest of the layout via a CSS variable
  // so Navbar + main padding shift down when AB is visible.
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--ab-height",
      visible ? AB_HEIGHT : "0px"
    );
    return () => {
      document.documentElement.style.setProperty("--ab-height", "0px");
    };
  }, [visible]);

  const dismiss = () => {
    try {
      localStorage.setItem(
        HIDE_KEY,
        String(Date.now() + HIDE_DAYS * 24 * 60 * 60 * 1000)
      );
    } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="announcement-bar"
      className="fixed top-0 inset-x-0 z-[55] bg-navy-900 text-white border-b border-gold-400/30"
      style={{ height: AB_HEIGHT }}
    >
      <div className="container-x h-full flex items-center justify-center gap-4 text-sm">
        <Sparkles className="h-4 w-4 text-gold-300 shrink-0" strokeWidth={1.75} />
        <p className="text-white/90 truncate">
          <span className="hidden sm:inline">{offer.tagline}</span>
          <span className="sm:hidden">{offer.label}</span>
        </p>
        <Link
          to="/contact"
          data-testid="announcement-cta"
          onClick={() => logAttribution("announcement_bar")}
          className="hidden sm:inline-flex items-center bg-gold-400 hover:bg-gold-500 text-navy-900 font-medium px-3.5 py-1 rounded-full transition-colors text-xs"
        >
          {offer.cta}
        </Link>
        <button
          type="button"
          onClick={dismiss}
          data-testid="announcement-dismiss"
          aria-label="Dismiss announcement"
          className="absolute right-3 top-1/2 -translate-y-1/2 text-white/50 hover:text-white"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
